import * as angular from "angular";
import {IController} from "angular";

export class DeviceInfoIconComponent implements IController {
  device: any;
  batteryLevel: any;

  icon: any;

  constructor() {
  }


  $onInit() {
    this.setIcon(this.batteryLevel);
  }

  $onChanges(changes) {
    if (changes.batteryLevel && !changes.batteryLevel.isFirstChange()) {
      this.setIcon(this.batteryLevel);
    }
  }

  private setIcon(batteryLevel) {
    this.icon = batteryLevel < 0.30 ? 'battery-low' : (batteryLevel < 0.75 ? 'battery-med' : 'battery-high');
  }
}

angular
  .module('bringoz.admin.commons')
  .component('deviceInfoIcon', {
    bindings: {
      device: '<?',
      batteryLevel: '<'
    },
    templateUrl: 'app/modules/commons/components/device-info-icon/device-info-icon.html',
    controller: DeviceInfoIconComponent
  });
